module.exports = __webpack_public_path__ + "static/img/slide-6.1ad11fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-6.jpg
// module id = sGPx
// module chunks = 1